import { render, staticRenderFns } from "./evaluaDetail.vue?vue&type=template&id=28d90ee0&scoped=true&"
import script from "./evaluaDetail.vue?vue&type=script&lang=js&"
export * from "./evaluaDetail.vue?vue&type=script&lang=js&"
import style0 from "./evaluaDetail.vue?vue&type=style&index=0&id=28d90ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d90ee0",
  null
  
)

export default component.exports